module.exports = __webpack_public_path__ + "static/media/zoom-white.e2a9496d.svg";